import React from 'react';
import clsx from 'clsx';

import s from './styles.module.less';

const AspectRatioBox = ({
  as: Component = 'div',
  aspect,
  aspectHeight,
  aspectWidth,
  className,
  contentClassName,
  children,
  style,
}) => {
  const aspectValue = (aspect ?? aspectHeight / aspectWidth) * 100;
  return (
    <Component className={clsx(s.root, className)} style={{ paddingBottom: `${aspectValue}%` }}>
      <div className={clsx(s.content, contentClassName)} style={style}>
        {children}
      </div>
    </Component>
  );
};

export default AspectRatioBox;
